import { Box } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { ImageContentBlock } from '~/components/image-content-block';
import { ShapesBanner } from '~/components/shapes-banner';
import { Space } from '~/components/space';

import { AboutUsTemplate } from '../model';

import { AwardsSection } from './awards-section';
import { HeroSection } from './hero-section';
import { MissionSection } from './mission-section';
import { PartnerSection } from './partner-section';
import { StatsSection } from './stats-section';
import { TeamMembersSection } from './team-members-section';
import { VisionSection } from './vision-section';

export function AboutUs({ aboutUsTemplate }: { aboutUsTemplate: AboutUsTemplate }) {
  return (
    <Box bg='white'>
      <HeroSection
        image={aboutUsTemplate.heroImage}
        mobileImage={aboutUsTemplate.heroImageMobile}
        subTitle={aboutUsTemplate.pageSubtitle}
        title={aboutUsTemplate.pageTitle}
      />
      <Space />
      <ContentContainer>
        <ImageContentBlock
          description={aboutUsTemplate.topImageContentBlock.description}
          image={aboutUsTemplate.topImageContentBlock.image}
          imageOrientation='left'
          mobileImage={aboutUsTemplate.topImageContentBlock.mobileImage}
          title={aboutUsTemplate.topImageContentBlock.title}
          renderImageAboveOnMobile
        />
      </ContentContainer>
      <Space />
      <PartnerSection partnerCompanies={aboutUsTemplate.partnerCompanies} />
      <StatsSection stats={aboutUsTemplate.stats} />
      <Space />
      <ContentContainer>
        <ImageContentBlock
          description={aboutUsTemplate.bottomImageContentBlock.description}
          image={aboutUsTemplate.bottomImageContentBlock.image}
          imageOrientation='right'
          mobileImage={aboutUsTemplate.bottomImageContentBlock.mobileImage}
          title={aboutUsTemplate.bottomImageContentBlock.title}
          renderImageAboveOnMobile
        />
      </ContentContainer>
      <Space />
      <AwardsSection awards={aboutUsTemplate.awards} />
      <Space />
      <TeamMembersSection teamMembers={aboutUsTemplate.teamMembers} />
      <Space />
      <VisionSection />
      <MissionSection missionStats={aboutUsTemplate.missionStats} missionTitleText={aboutUsTemplate.missionTitleText} />
      <ShapesBanner {...aboutUsTemplate.shapesBanner} />
    </Box>
  );
}
